import { createFileRoute } from "@tanstack/react-router";
import Apply from "@/pages/Apply";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/apply")({
  head: () => ({
    meta: [
      { title: "Claim Your Founding Number | Statlign" },
      { name: "description", content: "The first 1,000 Founding Members shape the engine and keep permanent perks. Apply in two minutes — the counter only moves one way." },
      { property: "og:title", content: "Claim Your Founding Number | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "The first 1,000 Founding Members shape the engine and keep permanent perks. Apply in two minutes — the counter only moves one way." },
      { name: "twitter:title", content: "Claim Your Founding Number | Statlign" },
      { name: "twitter:description", content: "The first 1,000 Founding Members shape the engine and keep permanent perks. Apply in two minutes — the counter only moves one way." },
    ],
  }),
  component: () => (
    <MainLayout>
      <Apply />
    </MainLayout>
  ),
});
